/**
 * 财务--》对账单页面汇总
 */

export default {
  // 客户对账页面，自定义打印明细的操作按钮名称
  print_detail_change_label: ['97276'], // 202506130817243803391

  open_invoice_sign_label: ['98206', '82635'], // 202506181725301832028，客户对账单，开票登记，不对公司全称，联系人，联系方式做强校验
  old_agent_reconciliation_add: ['89325'] ,// 202506201555120777718灰度开关 代理对帐单中添加对账tab 原先定制代理对帐单明细中含有添加对账 tab https://imagecdn.ymm56.com/ymmfile/static/resource/db05aecd-0e1d-41b4-83be-a29335b2fd10.png
  // 客户对账 筛选项添加 已对未核 状态
  customer_reconciliation_already_reconciliation_no_payment: ['84139'], // 202509051247290736067 84139  https://imagecdn.ymm56.com/ymmfile/static/resource/67927323-370d-434f-88b2-332331332323.png
  // 原79932定制的客户对账 状态下拉选项
  custom_customer_reconciliation_status_list: ['79932'], // https://imagecdn.ymm56.com/ymmfile/static/resource/676aca82-0a99-4310-ad8d-ee75d6248d00.png
  customer_reconciliationBill_invoicing_add_invoice_number: ['84139'], // 202509051247290736067 84139 客户对账单 开票信息 添加 发票号码
  // 客户对账明细 批量速配
  customer_reconciliation_detail_batch_speed_match:['83032','84139'],// 202309191511241005359 83032 ( 202509051247290736067 84139)客户对账单明细 批量速配
  customer_reconciliation_detail_batch_speed_match_fields: ['84139','97592','90100'], // 202509051247290736067 84139 客户对账单明细 批量速配 自定义字段，（捆包号或者货号）
  customer_reconciliation_detail_batch_speed_match_rule: ['84139'], // 202509051247290736067 84139 客户对账单明细 批量速配 修改检索规则
  customer_account_detail_matched_quickly:['97253'], // 202510151108188777147 客户对账单明细弹窗 批量速配
  customer_reconciliation_detail_payload_cname_replace_shipper: ['89220'], // 202511081035535708782 客户对账单明细  payload 中 cname 替换为 shipper
  customer_reconciliation_merge_bsite: ['90011','90277','91389','92528','73591','60292','90100','60998'], // 客户对账单合并网点
}
